import React, { useState } from 'react';
import MessageList from '../components/Messages/MessageList';
import Matches from '../components/Messages/Matches';
import { Container, Grid, Box, IconButton, useTheme, useMediaQuery } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

interface MessagesPageProps {
  onMatchSelect?: (isSelected: boolean) => void;
}

const MessagesPage: React.FC<MessagesPageProps> = ({ onMatchSelect }) => {
  const [selectedMatchId, setSelectedMatchId] = useState<string | null>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleSelectMatch = (matchId: string) => {
    setSelectedMatchId(matchId);
    onMatchSelect?.(true);
  };

  const handleBack = () => {
    setSelectedMatchId(null);
    onMatchSelect?.(false);
  };

  return (
    <Container maxWidth="xl" sx={{ 
      mt: 3, 
      height: 'calc(100vh - 250px)',
      mb: 4
    }}>
      <Grid container spacing={2} sx={{ height: '100%' }}>
        {/* Show Matches list on desktop or when no match is selected on mobile */}
        {(!isMobile || !selectedMatchId) && (
          <Grid item xs={12} sm={3}>
            <Box sx={{ 
              height: '100%', 
              borderRight: { sm: 1 }, 
              borderColor: 'divider',
              overflowY: 'auto'
            }}>
              <Matches onSelectMatch={handleSelectMatch} selectedMatchId={selectedMatchId} />
            </Box>
          </Grid>
        )}
        
        {/* Show MessageList on desktop or when a match is selected on mobile */}
        {(!isMobile || selectedMatchId) && (
          <Grid item xs={12} sm={9}>
            <Box sx={{ height: '100%' }}>
              {isMobile && selectedMatchId && (
                <IconButton onClick={handleBack} sx={{ mb: 2 }}>
                  <ArrowBackIcon />
                </IconButton>
              )}
              <MessageList selectedMatchId={selectedMatchId} />
            </Box>
          </Grid>
        )}
      </Grid>
    </Container>
  );
};

export default MessagesPage; 